
import Image from 'next/image';
import { X } from 'lucide-react';
import { TeamData } from '@/types/team'; 
import fixNewsContent from '@/lib/SVG_Render';

interface TeamMemberModalProps {
  member: TeamData;
  onClose: () => void;
}

const TeamMemberModal: React.FC<TeamMemberModalProps> = ({ member, onClose }) => {
  if (!member) return null;

  return (
    // Modal Overlay
    <div
      onClick={onClose}
      className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-60 backdrop-blur-xs bg-gray-900/50"
    >
      {/* Modal Content */}
      <div
        onClick={(e) => e.stopPropagation()} 
        className="relative bg-white text-gray-800 rounded-2xl shadow-xl w-11/12 max-w-2xl p-6 sm:p-8 m-4 transform transition-all duration-300 scale-95 opacity-0 animate-scale-in"
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 cursor-pointer hover:text-gray-700 transition-colors"
          aria-label="Close modal"
        >
          <X size={24} />
        </button>

        {/* Header Section */}
        <div className="flex flex-col sm:flex-row items-center gap-6 ">
          <div className="relative w-28 h-28 sm:w-36 sm:h-36 flex-shrink-0">
            <Image
              src={member.media?.[0]?.url || '/placeholder.jpg'}
              alt={`Profile picture of ${member.name}`}
              fill
              className="rounded-full object-contain "
              sizes="144px"
            />
          </div>
          <div className="text-center sm:text-left flex flex-col gap-2 ">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900">{member.name}</h2>
            <p className="text-sm text-gray-600">{member.position?.name}</p>
            <a
              href={""} 
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline text-sm md:text-base font-semibold"
            >
              {member.company.name} 
            </a>
          </div>
        </div>

        {/* Bio Section */}
        {member.content && (
          <div className="mt-5">
            <div
              className="prose prose-sm max-w-none text-sm text-gray-700 leading-relaxed "
              dangerouslySetInnerHTML={{ __html: fixNewsContent(member.content) }} 
            />
          </div>
        )}
        
      </div>
    </div>
  );
};


export default TeamMemberModal;